import { Mention } from "@tiptap/extension-mention";
import tippy from "tippy.js";
import { ReactRenderer } from "@tiptap/react";
import SuggestionList from "./SuggestionList";
import "./Mention.css";

export const MentionExtension = Mention.extend({
  addStorage() {
    return {
      userList: [],
    };
  },
  addAttributes() {
    return {
      id: { default: null },
      fullName: { default: null },
      avatar: { default: null },
    };
  },
  // Add parseHTML function to parse the custom element when click on edit icon from comment list
  parseHTML() {
  return [
    {
      tag: 'span[class*="mui-chip-mention"]',
      getAttrs: (element) => {
        const id = element.getAttribute('data-id');
        const fullName = element.getAttribute('data-fullname');
        const label = element.getAttribute('data-label') || fullName;
        
        return {
          id: id,
          label: label,
          fullName: fullName || label,
        };
      },
    },
  ];
},
  renderHTML({ node }) {
    return [
      "span",
      {
        class: "mui-chip-mention",
        "data-id": node.attrs.id,
        "data-fullname": node.attrs.fullName,
      },
      `@${node.attrs.fullName}`,
    ];
  },
}).configure({
  HTMLAttributes: {
    class: "mention",
  },
  suggestion: {
    char: "@",
    items: ({ query, editor }) => {
      const users = editor.storage.mention.userList || [];
      return (
        users?.length > 0 &&
        users
          ?.filter((user: any) =>
            user.label.toLowerCase().includes(query.toLowerCase())
          )
          .slice(0, users?.length ?? 10)
      );
    },
    render: () => {
      let popup: any;
      let component: any;

      return {
        onStart: (props) => {
          component = new ReactRenderer(SuggestionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) return;

          popup = tippy(document.body, {
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
            getReferenceClientRect: () => {
              const rect = props.clientRect?.();
              return rect || new DOMRect(0, 0, 0, 0);
            },
          });
        },
        onUpdate(props) {
          component.updateProps(props);
          if (!props.clientRect) {
            return;
          }
          popup?.setProps({
            getReferenceClientRect: props.clientRect,
          });
        },
        onKeyDown(props) {
          return component?.ref?.onKeyDown?.(props) || false;
        },
        onExit() {
          popup?.destroy();
          component?.destroy();
        },
      };
    },
  },
});
